import { render, staticRenderFns } from "./ResumenPago.vue?vue&type=template&id=3ed63b18&scoped=true&"
import script from "./ResumenPago.vue?vue&type=script&lang=js&"
export * from "./ResumenPago.vue?vue&type=script&lang=js&"
import style0 from "./ResumenPago.vue?vue&type=style&index=0&id=3ed63b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed63b18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VIcon,VSimpleTable})
